export const cashinRejectedReason = {
    PayoutFailed: 'PayoutFailed',
    RejectedByBookmaker: 'RejectedByBookmaker',
    Rejected: 'Rejected'
};
